<template>
  <el-card v-loading="loading">
  <div ref="scrollContainer" id="page-panel" >
    <!-- <resize-observer @notify="__resizeHanlder" /> -->

      <div class="customer-top-nav">
        <div class="title">
          <span>{{$t('reports.names.'+reportCode)}}</span><br>
        </div>
        <div class="controls no-print">
          <el-dropdown size="small" type="default" class="">
            <el-button type="primary" size="small">
              <i class="el-icon-download"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="downloadReport('csv')"><i class="mdi mdi-file-excel"/> CSV</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
           <el-button type="primary" @click="openFilterDialog" size="small"><i class="mdi mdi-filter"></i> </el-button>
        </div>
      </div>

      <p>
        <span class="fs-14 secondary-text">{{companyName}}</span><br>
        <span class="fs-14 secondary-text">{{currentFilterPeriod}}</span>
      </p>
      <div v-if="data != null && (data==null || data.length==0)" class="text-center m-30 mt-70" >
        <span class="fs-14">Aucune données n'est inscrit dans les comptes grand livres</span>
      </div>
      <el-collapse v-model="activeGlAccounts">
        <el-collapse-item v-for="(account, index) in data" :key="account.id" :title="getAccountName(account)" :name="account.number">
          <span class="secondary-text">{{account.description}}</span>
          <el-table :data="summaryByGl[index].entry" :style="tableWidth" ref="summary" class="m-20">
            <el-table-column  align="left" label="Sommaire">
              <template slot-scope="scope">
                <span class="fs-14" v-if="scope.row.name.header"><strong>{{$t('reports.GL.headers.'+scope.row.name.name)}}</strong></span>
              </template>
            </el-table-column>
            <el-table-column  align="center" v-for="cur in summaryByGl[index].dynamicCurrenyColumns" :key="cur" :label="cur" width="200">
              <template slot-scope="scope">
                <span class="fs-14">{{scope.row[cur]}} $</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change=" v => handlePageChange(index, v)"
            :small="paginationByGl[index].small"
            :current-page="paginationByGl[index].page"
            :page-sizes="paginationByGl[index].sizes"
            :page-size.sync="paginationByGl[index].size"
            :layout="paginationByGl[index].layout"
            :total="totalRecords[index]"
            :hide-on-single-page="true"
          ></el-pagination>
          <el-table :data="listInPage[index]" style="width: 100%" class="m-20" :cell-style="{padding:'2px'}">
            <el-table-column label="Transaction/Référence">
              <template slot-scope="scope">
                {{$t('gl.entries.type.'+scope.row.type)}}
                <span><br>
                  <span v-if="scope.row.subType != null && scope.row.subType != '' ">{{$t('gl.entries.subType.'+scope.row.subType)}}</span>
                  <span v-if="isArray(scope.row.reference)">
                    <span v-for="ref in scope.row.reference">
                      <PortausLink :id="ref.id" :label="ref.number" :type="ref.type" fs="fs-12"></PortausLink>
                    </span>
                  </span>
                  <span v-else>
                    <PortausLink :id="scope.row.reference.id" :label="scope.row.reference.number" :type="scope.row.reference.type" fs="fs-12"></PortausLink>
                  </span>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Date/Note">
              <template slot-scope="scope">
                {{_moment(scope.row.date)}}
                <span v-if="scope.row.note!=null">
                  <br>
                  <span v-if="scope.row.subType != null && scope.row.subType != ''">{{$t('gl.entries.subType.'+scope.row.subType)}}</span>
                  <span v-if="scope.row.note.note!=null">{{scope.row.note.note}}</span>
                  <span v-else>
                    <span v-if="isArray(scope.row.note)">
                      <span v-for="ref in scope.row.note">
                        <PortausLink :id="ref.id" :label="ref.number" :type="ref.type" fs="fs-12"></PortausLink>
                      </span>
                    </span>
                    <span v-else>
                      <PortausLink :id="scope.row.note.id" :label="scope.row.note.number" :type="scope.row.note.type" fs="fs-12"></PortausLink>
                    </span>
                  </span>
                  <!-- <PortausLink  v-else :id="scope.row.note.id" :label="scope.row.note.number" :type="scope.row.note.type" fs="fs-12"></PortausLink> -->
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Debit" width="150" prop="debit">
              <template slot-scope="scope">
                <span v-if="scope.row.debit">{{$n(scope.row.debit,'currency',scope.row.currency)}}</span>
                <span v-else> -- </span>
              </template>
            </el-table-column>
            <el-table-column label="Credit" width="150" prop="credit">
              <template slot-scope="scope">
                <span v-if="scope.row.credit">{{$n(scope.row.credit,'currency',scope.row.currency)}}</span>
                <span v-else> -- </span>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    <reportFilter :visible="reportFilterVisible"
                  @close="closeFilterDialog"
                  :period="period"
                  :predefinedPeriod="predefinedPeriod"
                  :date="filters.date"
                  @applyFilter="handleFilter">
    </reportFilter>
  </div>
</el-card>
</template>
<script>
//import Section
import generalLedgerAPI from '@/services/API/general-ledger.js'
import moment from 'moment'
import reportUtil from '@/utils/report-util.js'
import reportFilter from './report-filter'
import PortausLink from '@/components/portaus-link'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name : "report-gl",
  props : {
    width : {
      type : Number,
      default : 100
    },
    fiscalEndDay : Number,
    fiscalEndMonth : Number,
    lastFiscalYearDate : Object,
    fiscalYearDate : Object,
    month : Object,
    lastMonth : Object,
    companyName : '',
  },
  data() {
    return {
      activeGlAccounts : [],
      output : null,
      data : [],
      openBalance : [],
      loading:true,
      reportFilterVisible : false,
      filters : {
        range : 'MONTH',
        startDate : null,
        endDate : null,
      },
      pageWidth : null,
      pageHeight : null,
      nbEntriesByGl : 100,
      paginationByGl : [],
      paginationControl: null,
      paginationTemplate: {
				page: 1,
				size: 20,
				sizes: [10, 15, 20, 30, 50, 100],
				layout: 'total, ->, prev, pager, next, sizes',
				small: false
			},
    };
  },
  components : {
    reportFilter,
    PortausLink
  },
  computed : {
    nbEntries () {
      let nbEntries = 0;
      _.forEach(this.data, gl => nbEntries += gl.entries.length);
      return nbEntries;
    },
    currentFilterPeriod(){
      return reportUtil.currentFilterPeriod(this.fiscalYearDate,this.lastFiscalYearDate,this.filters.range,this.filters.startDate,this.filters.endDate )
    },
    period(){
      return _.find(this.predefinedPeriod, p=>{return p.code==this.filters.range})
    },
    predefinedPeriod(){
      if(this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        return [
          {code : 'MONTH', description:this.month.startDate.format('DD MMM YYYY') + '-'+this.month.endDate.format('DD MMM YYYY')},
          {code : 'LAST_MONTH', description:this.lastMonth.startDate.format('DD MMM YYYY') + '-'+this.lastMonth.endDate.format('DD MMM YYYY')},
          {code : 'FISCAL_YEAR',description:this.fiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.fiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'LAST_FISCAL_YEAR',description:this.lastFiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.lastFiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'CUSTOM', range:true}
        ]
      }else{
        return [];
      }

    },
    tableWidth(){
      return 'width : ' + this.width + 'px;';
    },
    reportCode(){
      return this.$route.params.code;
    },
    totalRecords() {
			return _.map(this.data, (gl) => gl.entries.length);
		},
    summaryByGl(){
      const summary = [];
      _.forEach(this.data, gl => {
        let creditAmount = 0;
        let debitAmount = 0;
        let total = 0;
        let entry = [];
        let totalByCurrencies = [];
        let dynamicCurrenyColumns = [];
        _.forEach(gl.entries, e => {
          if (totalByCurrencies[e.currency] == null) {
            totalByCurrencies[e.currency] = { creditAmount:0, debitAmount:0, total:0 };
            dynamicCurrenyColumns.push(e.currency);
          }
          totalByCurrencies[e.currency].creditAmount += e.credit != null ? e.credit : 0;
          totalByCurrencies[e.currency].debitAmount += e.debit != null ? e.debit : 0;
        });

        const openBalance = {};
        const debitEntry = {};
        const creditEntry = {};
        const totalEntry ={};

        _.forIn(totalByCurrencies, (t, cur) => {
          let balance = _.find(this.openBalance, op => op.glNumber === gl.number && op.currency === cur
          );
          var balanceNumber = 0;
          if (balance != null) {
            balanceNumber = Math.round((parseFloat(balance.open_balance_debit) - parseFloat(balance.open_balance_credit)) * 100)/100;
          }

          openBalance[cur] = balanceNumber;
          openBalance.name = { name: 'openBalance', header:true };

          t.creditAmount = Math.round(t.creditAmount*100)/100;
          t.debitAmount = Math.round(t.debitAmount * 100) /100;

          t.total = Math.round((balanceNumber + t.debitAmount - t.creditAmount) * 100) / 100
          debitEntry[cur] = t.debitAmount;
          debitEntry.name = { name: 'debit', header:true };
          creditEntry[cur] = t.creditAmount;
          creditEntry.name = { name: 'credit', header:true };
          totalEntry[cur] = t.total;
          totalEntry.name = { name: 'balance', header:true };


        })

        entry.push(openBalance);
        entry.push(debitEntry);
        entry.push(creditEntry);
        entry.push(totalEntry);

        summary.push({ dynamicCurrenyColumns, entry });
      });
      return summary;
    },
    listInPage(){
      let control = this.paginationControl  ;
      // if(this.paginationControl!=null) {
        return _.map(this.data, (gl, index) => {
          let from = (this.currentPage[index] - 1) * this.itemPerPage[index]
          let to = from + (this.itemPerPage[index]*1)
          //return this.listSortered.slice(from, to)
          return gl.entries.slice(from, to)
        });
      // }
      // return [];
    },
    currentPage(){
      let control = this.paginationControl  ;
      return _.map(this.paginationByGl, (gl) => gl.page)

		},
		itemPerPage() {
      return _.map(this.paginationByGl, (gl) => gl.size);
		},
    ...mapGetters('users',['filterUserWithRoleRep']),
  },
  methods : {
    getAccountName (account) {
      if (account.id == null) {
        return this.$i18n.t(`gl.entries.uncategorizedGL`);
      }
      return account.name + '-' + account.number;
    },
    handlePageChange(index, valeur){
      this.paginationByGl[index].page = valeur;
      this.paginationControl = index+'-'+valeur;
    },

    isArray(array){
      return _.isArray(array);
    },
    downloadReport(format){
      let filters = this.prepareFilterForRequest();
      filters.format=format

      let filename = 'GL_'+moment(this.filters.date).format('YYYY-MM-DD');
      filename+="."+format;

      return generalLedgerAPI.downloadReport(filename, filters);
    },
    handleFilter(filters){
      localStorage.gl_range=filters.period.code;
      localStorage.gl_startDate = filters.dateRange[0];
      localStorage.gl_endDate = filters.dateRange[1];


      this.setFilters();
      this.fetchData();
    },
    openFilterDialog(){
      this.reportFilterVisible = true;
    },
    closeFilterDialog(){
      this.reportFilterVisible=false;
    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
			this.$router.push(index);
    },
    _moment(date, format='l'){
      return moment(date).format(format);
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if(row.span){
          return {rowspan:1, colspan:this.nbColums+2}
        }else{
          return {rowspan:1, colspan:1}
        }
      },
    initPagination (){
      _.forEach(this.data, (gl) => {
        this.paginationByGl.push(_.cloneDeep(this.paginationTemplate));
      })
    },
		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700),

    prepareFilterForRequest () {
      let filters = _.cloneDeep(this.filters);
      if(filters.startDate!=null){
        filters.startDate = moment(filters.startDate).format('YYYY-MM-DD Z');
      }
      if(filters.endDate!=null){
        filters.endDate = moment(filters.endDate).add(1, 'days').format('YYYY-MM-DD Z');
      }
      return filters;
    },
    fetchData(){
      this.loading = true;
      this.total = 0.00;


      const filters = this.prepareFilterForRequest();


      return generalLedgerAPI.fetchJournalEntries(filters)
      .then((data) => {
        this.data = data.glEntries;
        this.openBalance = data.openBalance;
        this.initPagination();
        this.loading = false;
      })
      .catch(err=>{
        console.log(err);
        this.loading = false;
        this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard')
      })
    },
    setFilters(){
      if(localStorage.gl_range==null){
        localStorage.gl_range='MONTH';
      }

      this.filters.range=localStorage.gl_range;

      if(this.filters.range=='FISCAL_YEAR' && this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        localStorage.gl_startDate = this.fiscalYearDate.startDate;
        localStorage.gl_endDate = this.fiscalYearDate.endDate;
      }else if(this.filters.range=='LAST_FISCAL_YEAR' && this.lastFiscalYearDate.startDate!=null && this.lastFiscalYearDate.endDate!=null){
        localStorage.gl_startDate = this.lastFiscalYearDate.startDate;
        localStorage.gl_endDate = this.lastFiscalYearDate.endDate;
      }else if(this.filters.range=='MONTH'){
        localStorage.gl_startDate = this.month.startDate;
        localStorage.gl_endDate = this.month.endDate;
      }else if(this.filters.range=='LAST_MONTH'){
        localStorage.gl_startDate = this.lastMonth.startDate;
        localStorage.gl_endDate = this.lastMonth.endDate;
      }

      this.filters.startDate = localStorage.gl_startDate;
      this.filters.endDate = localStorage.gl_endDate;
    },
  },
  mounted(){
    this.setPageWidth();
    // this.$refs.summary.$options._parentVnode.elm.classList.remove('el-table--enable-row-hover')
  },
  created(){
    this.loading = true;
    this.setFilters();
    this.fetchData();
  },
  beforeDestroy(){
    this.data = [];
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

@media print {
  body, html { margin-top:0%;
    font-size:0.8em;
     display:block;
     height:100%;
     width:100%;
     position:unset !important;
     background:none;
     overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset
   }
   .no-print{
   	display:none;
   }
   .el-card{
     border:none;
     width:100%;
   }

   @page {
     size: portrait;
   }


}


.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>
